"use client"

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { OfferBannerItem } from './OfferBannerSectionComponent';

const Slider = dynamic(() => import('react-slick'), { ssr: false });

interface OfferBannerSliderProps {
    items: OfferBannerItem[];
    totalCards?: number;
    imageHeight?: string;
    sectionStyles?: Record<string, any>;
    sliderEnabled?: boolean;
    autoPlay?: boolean;
    slideInterval?: number;
}

const OfferBannerSlider: React.FC<OfferBannerSliderProps> = ({
    items,
    totalCards,
    imageHeight = '200px',
    sectionStyles,
    sliderEnabled = false,
    autoPlay = false,
    slideInterval = 4000,
}) => {
    const banners = totalCards ? items.slice(0, totalCards) : items;

    if (!banners.length) return null;

    if (!sliderEnabled) {
        return (
            <section style={{ padding: '20px 0', backgroundColor: 'transparent', ...sectionStyles }}>
                <div
                    style={{
                        display: 'flex',
                        gap: '16px',
                        overflowX: 'auto',
                        scrollSnapType: 'x mandatory',
                        width: '100%',
                        paddingBottom: '8px',
                    }}
                >
                    {banners.map((item, index) => (
                        <div
                            key={`${item.offer_url}-${index}`}
                            id={`offer-banner-${index}`}
                            style={{
                                flex: '0 0 100%',
                                width: '100%',
                                scrollSnapAlign: 'start',
                            }}
                        >
                            <Link href={item.offer_url} target="_blank" rel="noopener noreferrer">
                                <div style={{ position: 'relative', width: '100%', height: imageHeight, borderRadius: '10px', overflow: 'hidden' }}>
                                    <Image
                                        src={item.banner_image}
                                        alt={`Offer Banner ${index + 1}`}
                                        fill
                                        style={{ objectFit: 'contain' }}
                                        unoptimized
                                    />
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </section>
        );
    }

    const settings = {
        dots: false,
        arrows: false,
        infinite: banners.length > 1,
        autoplay: autoPlay && banners.length > 1,
        autoplaySpeed: slideInterval,
        pauseOnHover: true,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
    };

    return (
        <section style={{ padding: '20px 0', backgroundColor: 'transparent', ...sectionStyles }}>
            <Slider {...settings}>
                {banners.map((item, index) => (
                    <div key={`${item.offer_url}-${index}`} id={`offer-banner-${index}`}>
                        <Link href={item.offer_url} target="_blank" rel="noopener noreferrer">
                            <div style={{ position: 'relative', width: '100%', height: imageHeight, borderRadius: '10px', overflow: 'hidden' }}>
                                <Image
                                    src={item.banner_image}
                                    alt={`Offer Banner ${index + 1}`}
                                    fill
                                    style={{ objectFit: 'contain' }}
                                    unoptimized
                                />
                            </div>
                        </Link>
                    </div>
                ))}
            </Slider>
        </section>
    );
};

export default OfferBannerSlider;
